import { EventPubSub } from './pubSub.js';
import { CLICK } from '../../../shared/enums/events.js';

export default {
  load: () => {
    EventPubSub.subscribe(CLICK, (e) => {
      const { event, $target, options } = e;
      const $consentLink = $target.closest('.util.eu-data-subject-requests');
      if ($consentLink) {
        event.preventDefault();
        window.location.href = 'https://www.adpractitioners.com/eu-data-request?site=money.com';
      }
    });
  },
};
